import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Tooltip from "@mui/material/Tooltip";
import { HelpCircle } from "lucide-mui";

interface NewProspectsOnlyFieldProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  tenantName: string;
  disabled?: boolean;
}

/**
 * "Only find prospects not seen before" on an order: its agents are refused
 * every company the tenant already prospected. Unchecked, repeats come through
 * marked "Seen N×" on the collection.
 */
export default function NewProspectsOnlyField({
  checked,
  onChange,
  tenantName,
  disabled,
}: NewProspectsOnlyFieldProps) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <FormControlLabel
        sx={{ mr: 0.5 }}
        control={
          <Checkbox
            size="small"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled}
          />
        }
        label="Only find prospects not seen before"
        slotProps={{ typography: { variant: "body2" } }}
      />
      <Tooltip
        title={`Skips every company already prospected for ${tenantName}: found by an earlier run or a signal, or added by hand. Left unchecked, the agent may include them again, and each repeat is marked "Seen N×" on the collection with where it was found before.`}
      >
        <Box
          component="span"
          aria-label="About new prospects only"
          sx={{ display: "inline-flex", color: "text.secondary", cursor: "help", "& svg": { fontSize: 16 } }}
        >
          <HelpCircle />
        </Box>
      </Tooltip>
    </Box>
  );
}
